import { useTheme, useMediaQuery, Card, Stack, CardContent, Box, Typography, Table, TableContainer, Paper, TableHead, TableBody, TableRow, TableCell, TableFooter, Link } from '@mui/material';
import FilingSchedule from '../../../../../types/filers/fillingSchedule';

interface Props {
    schedules: FilingSchedule[]
    bq?: boolean;
    year?: number;
}

const FilingScheduleTable = (props: Props): JSX.Element => {
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    const lateContributionSchedule = props.schedules.find(schedule => schedule.description === 'Late Contribution Period');
    const lateContributionYear = lateContributionSchedule ? lateContributionSchedule.year : 0;
    const lateContributionStartDate = lateContributionSchedule ? lateContributionSchedule.startDate : '';
    const lateContributionEndDate = lateContributionSchedule ? lateContributionSchedule.endDate : '';

    return (
        <Box>
            {
                isSM ?
                    props.schedules.map((schedule, index) => (
                        <Card variant="outlined" key={index} sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Stack spacing={1}>
                                    <Typography variant="subtitle1" color="primary">
                                        {schedule.year}
                                    </Typography>
                                    <Typography variant="body2">
                                        <b>Report Type: </b>{schedule.description}{schedule.description === '60 Day' && <sup>{'\u2020'}</sup>}
                                    </Typography>
                                    <Typography variant="body2">
                                        <b>Begin Reporting Period: </b>{schedule.startDate.toString()}
                                    </Typography>
                                    <Typography variant="body2">
                                        <b>End Reporting Period: </b>{schedule.endDate.toString()}
                                    </Typography>
                                    <Typography variant="body2">
                                        <b>Date Due: </b>{schedule.dueDate.toString()}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>
                    ))
                    :
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant='subtitle2' fontWeight={550}>
                                            Report Year
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='subtitle2' fontWeight={550}>
                                            Report Type
                                        </Typography>
                                    </TableCell>
                                    <TableCell align='center'>
                                        <Typography variant='subtitle2' fontWeight={550}>
                                            Begin Reporting Period
                                        </Typography>
                                    </TableCell>
                                    <TableCell align='center'>
                                        <Typography variant='subtitle2' fontWeight={550}>
                                            End Reporting Period
                                        </Typography>
                                    </TableCell>
                                    <TableCell align='center'>
                                        <Typography variant='subtitle2' fontWeight={550}>
                                            Date Due
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.schedules.map((schedule, index) => (
                                    <TableRow key={index}>
                                        {index == 0 ? <TableCell>{schedule.year}</TableCell> : <TableCell></TableCell>}
                                        <TableCell>
                                            <Typography variant='body2' color="primary">
                                                {schedule.description} {schedule.description === '60 Day' && <sup>{'\u2020'}</sup>}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align='center'>{'' + schedule.startDate}</TableCell>
                                        <TableCell align='center'>{'' + schedule.endDate}</TableCell>
                                        <TableCell align='center'>{'' + schedule.dueDate}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            {props.bq &&
                                <TableFooter>
                                    {(props.year ?? 0) % 2 == 0 && 
                                    <TableRow>
                                        <TableCell colSpan={5}>
                                            <Typography variant="body1" component={'p'} gutterBottom>
                                                <sup>{'\u2020'} </sup>
                                                {`The Report will begin on 01/01/${props.year} if the committee was organized before ${props.year}.`}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>}
                                    <TableRow>
                                        <TableCell colSpan={5}>
                                            {
                                                (props.year ?? 0) % 2 == 0 &&
                                                <Typography variant="body1" component={'p'} gutterBottom>
                                                    * 72-Hour Reporting (Late Contribution Reports): State ballot question committees that receive and deposit contributions of $500 or more after the 18th day, but more than 72 hours, before the date of a general election must file a disclosure report within 72 hours of depositing the contributions received. The late contribution reporting period for {lateContributionYear} is {lateContributionStartDate} through {lateContributionEndDate}.
                                                </Typography>
                                            }
                                            <Typography variant="body1" component={'p'} gutterBottom>
                                                ** Dissolution: Once the question has been decided by the voters, a ballot question committee should disolve promptly. Please see <Link href="https://ocpf2.blob.core.windows.net/pdf/legaldocs/M-24-02.pdf" target="_blank">M-24-02</Link>.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>

                                </TableFooter>
                            }
                        </Table>
                    </TableContainer>
            }



            {props.bq && isSM &&

                <Card variant="outlined" key={'note'} sx={{ marginBottom: 2 }}>
                    <CardContent>
                        <Stack spacing={1}>
                            <Typography variant="subtitle1" color="primary">
                                Notes
                            </Typography>

                            {(props.year ?? 0) % 2 == 0 &&
                                <Typography variant="body2" gutterBottom>
                                    <sup>{'\u2020'} </sup>
                                    {`The Report will begin on 01/01/${props.year} if the committee was organized before ${props.year}.`}
                                </Typography>
                            }

                            <Typography variant="body2" gutterBottom>
                                * 72-Hour Reporting (Late Contribution Reports): State ballot question committees that receive and deposit contributions of $500 or more after the 18th day, but more than 72 hours, before the date of a general election must file a disclosure report within 72 hours of depositing the contributions received. The late contribution reporting period for {lateContributionYear} is {lateContributionStartDate} through {lateContributionEndDate}.
                            </Typography>
                            {
                                (props.year ?? 0) % 2 == 0 &&
                                <Typography variant="body2" gutterBottom>
                                    ** Dissolution: Once the question has been decided by the voters, a ballot question committee should be preparing the dissolution of the committee. Please see M-24-02.
                                </Typography>
                            }

                        </Stack>
                    </CardContent>
                </Card>
            }




        </Box>
    );
};

export default FilingScheduleTable;